import { render, staticRenderFns } from "./TheHeaderDropdownNotifications.vue?vue&type=template&id=53e127aa&"
import script from "./TheHeaderDropdownNotifications.vue?vue&type=script&lang=js&"
export * from "./TheHeaderDropdownNotifications.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports